import getCookies from '../../utils/getCookies.js'
import setCookies from '../../utils/setCookies.js'

export default
{
    components:
    {

    },

    data()
    {
        return {
            href: '',
            nbItems: 0
        }
    },

    created()
    {
        this._tmpNbItems = 0
        this._isMySelection = true

        this.eventHub.$on('fav:update', this.onUpdate)
        this.eventHub.$on('selection:delete', this.onDeleteSelection)
    },

    mounted()
    {
        this.onUpdate()
    },

    methods:
    {
        onUpdate()
        {
            clearTimeout(this._timer)
            this.$el.children[0].classList.add('is-animating')

            this.href = getCookies('selections')

            this._tmpNbItems = this.href.split` `.length === 1 && this.href.split` `[0] === '' ? 0 : this.href.split` `.length

            if(this._tmpNbItems > 0)
            {
                this.$el.children[0].classList.add('is-counter-visible')
            }
            else
            {
                this.$el.children[0].classList.remove('is-counter-visible')
            }

            if(this._tmpNbItems < this.nbItems)
            {
                this.$el.children[0].classList.add('is-from-top')
            }
            else
            {
                this.$el.children[0].classList.add('is-from-bottom')
            }

            if(this.$route.name === 'my-selection')
            {
                this.$router.push('/my-selection?posts=' + this.href)
            }

            this._timer = setTimeout(() =>
            {
                this.nbItems = this._tmpNbItems
                this.$el.children[0].classList.remove('is-animating')
                this.$el.children[0].classList.remove('is-from-top')
                this.$el.children[0].classList.remove('is-from-bottom')
            }, 500)
        },

        onDeleteSelection()
        {
            setCookies('selections', '', 10)

            this.onUpdate()
        },

        onToggleSidebar()
        {
            this.$emit('toggle:sidebar')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-fav-manager/script.js